let googleMapsPromise: Promise<typeof google.maps> | undefined;

export const resetGoogleMapsApi = () => {
  googleMapsPromise = undefined;
};

export const loadGoogleMapsApi = (): Promise<typeof google.maps> => {
  if (window.google?.maps) {
    return Promise.resolve(window.google.maps);
  }

  if (!googleMapsPromise) {
    googleMapsPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${window.clutter.config.google.mapsApiKey}&libraries=places`;
      script.async = true;
      script.onload = () => resolve(window.google.maps);
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  return googleMapsPromise;
};
